import { render, staticRenderFns } from "./Gasto.vue?vue&type=template&id=586d2edc"
import script from "./Gasto.vue?vue&type=script&lang=js"
export * from "./Gasto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports